import { queryOptions } from '@tanstack/react-query';
import {
  GwiResearchService,
  type AskGwiResearchDto,
  type GwiResearchQaResponseDto,
} from '@inference.engine/api-client/web';

import { inferenceHttp } from '@/lib/api/http-client';

import { GWI_RESEARCH_QUERY_KEYS, type GwiResearchCategory } from './query-keys';

const getPersonaResearchHistory = async (
  personaId: string,
  category?: GwiResearchCategory,
): Promise<GwiResearchQaResponseDto[]> => {
  const response = await GwiResearchService.history({
    client: inferenceHttp,
    throwOnError: true,
    path: { personaId },
    query: { category },
  });
  return response.data;
};

export const askPersonaResearch = async (
  personaId: string,
  body: AskGwiResearchDto,
): Promise<GwiResearchQaResponseDto> => {
  const response = await GwiResearchService.ask({
    client: inferenceHttp,
    throwOnError: true,
    path: { personaId },
    body,
  });
  return response.data;
};

export const deletePersonaResearch = async (personaId: string, id: string): Promise<void> => {
  await GwiResearchService.delete({
    client: inferenceHttp,
    throwOnError: true,
    path: { personaId, id },
  });
};

export const personaResearchHistoryQuery = (
  personaId: string | null | undefined,
  category?: GwiResearchCategory,
) =>
  queryOptions({
    queryKey: GWI_RESEARCH_QUERY_KEYS.history(personaId!, category),
    queryFn: () => getPersonaResearchHistory(personaId!, category),
    enabled: !!personaId,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });
